import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//react router
import { BrowserRouter } from "react-router-dom";
//styles
import GlobalStyles from "./styles/GlobalStyles";
import { trackEvent, trackWebVital } from "./utils/analytics";

document.addEventListener("click", (event) => {
  const link = (event.target as HTMLElement).closest<HTMLAnchorElement>("a");
  if (!link) return;

  if (link.href.startsWith("tel:")) {
    trackEvent("phone_click", { link_url: link.href });
  } else if (link.href.startsWith("mailto:")) {
    trackEvent("email_click", { link_url: link.href });
  } else if (link.href.includes("calendly.com/agwipol")) {
    trackEvent("booking_click", {
      booking_provider: "calendly",
      link_url: link.href,
      link_location: "link",
    });
  }
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalStyles />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(trackWebVital);
